var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreateInquiry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.94666 12.2194C0.854167 12.2193 0.762719 12.1999 0.678131 12.1625C0.593543 12.125 0.517667 12.0704 0.455326 12.0021C0.391859 11.9344 0.343429 11.854 0.313212 11.7662C0.282996 11.6784 0.271675 11.5852 0.279993 11.4928L0.443326 9.69677L7.98866 2.1541L10.3467 4.51143L2.80333 12.0534L1.00733 12.2168C0.987159 12.2186 0.966913 12.2195 0.94666 12.2194ZM10.8173 4.0401L8.45999 1.68277L9.87399 0.268767C9.93591 0.206782 10.0094 0.15761 10.0904 0.12406C10.1713 0.0905106 10.258 0.0732422 10.3457 0.0732422C10.4333 0.0732422 10.52 0.0905106 10.601 0.12406C10.6819 0.15761 10.7554 0.206782 10.8173 0.268767L12.2313 1.68277C12.2933 1.74468 12.3425 1.81821 12.376 1.89914C12.4096 1.98007 12.4269 2.06682 12.4269 2.15443C12.4269 2.24204 12.4096 2.32879 12.376 2.40973C12.3425 2.49066 12.2933 2.56418 12.2313 2.6261L10.818 4.03943L10.8173 4.0401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreateInquiry);
export default __webpack_public_path__ + "static/media/icon_create_inquiry.1154c6528690988d85eca054a9eb4e14.svg";
export { ForwardRef as ReactComponent };